import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/lib/auth";
import { LanguageProvider } from "@/lib/i18n";
import { CurrencyProvider } from "@/lib/currency";
import { Toaster } from "@/components/ui/sonner";

import AuthCallback from "@/components/AuthCallback";
import ProtectedRoute from "@/components/ProtectedRoute";
import AssistantWidget from "@/components/AssistantWidget";

import Home from "@/pages/Home";
import Cabins from "@/pages/Cabins";
import CabinDetail from "@/pages/CabinDetail";
import Experiences from "@/pages/Experiences";
import Story from "@/pages/Story";
import Gallery from "@/pages/Gallery";
import Contact from "@/pages/Contact";
import Book from "@/pages/Book";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Profile from "@/pages/Profile";
import Admin from "@/pages/Admin";

function ScrollToTop() {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);
    return null;
}

function AppRouter() {
    const location = useLocation();
    // CRITICAL: synchronous check during render to handle OAuth fragment
    if (location.hash?.includes("session_id=")) {
        return <AuthCallback />;
    }
    return (
        <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/cabins" element={<Cabins />} />
            <Route path="/cabins/:slug" element={<CabinDetail />} />
            <Route path="/experiences" element={<Experiences />} />
            <Route path="/story" element={<Story />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/book" element={<Book />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
            <Route path="/admin" element={<ProtectedRoute requireAdmin><Admin /></ProtectedRoute>} />
            <Route path="*" element={<Home />} />
        </Routes>
    );
}

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <LanguageProvider>
                    <CurrencyProvider>
                        <AuthProvider>
                            <ScrollToTop />
                            <AppRouter />
                            <AssistantWidget />
                            <Toaster richColors position="top-center" />
                        </AuthProvider>
                    </CurrencyProvider>
                </LanguageProvider>
            </BrowserRouter>
        </div>
    );
}

export default App;
